var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNominationForm)?_c('nomination'):_c('v-card',[_c('v-card-title',[_c('h2',{staticClass:"checkout-h2"},[_vm._v(_vm._s(_vm.natalLuz ? 'Termos - Covid-19' : 'Formato do seu ingresso'))])]),_c('delivery-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }